import React from "react";
import HeaderSix from "../header/HeaderSix";
import BannerEight from "../elements/BannerEight";
import ServiceFour from "../elements/ServiceFour";
import AboutSix from "../elements/AboutSix";
import CounterTwo from "../elements/CounterTwo";
import PortfolioSix from "../elements/PortfolioSix";
import BrandTwo from "../elements/BrandTwo";
import FooterSix from "../footer/FooterSix";
import WhychooseUs from "../elements/WhychooseUs";
import TestimonialsBrand from "../elements/TestimonialsBrand";
import TeamMembers from "../inner/TeamMembers";
import BannerOne from "../elements/BannerOne";
import PortfolioTwo from "../elements/PortfolioTwo";
import ContactTwo from "../elements/ContactTwo";
import WorkingProcessThree from "../elements/WorkingProcessThree";
import Portfolio from "../elements/Portfolio";
import VideoBanner from "../elements/VideoBanner";
import Pricing from "../elements/Pricing";

function HomeEight() {
  return (
    <div>
      <div className="index-Five">
        {/* <HeaderSix/> */}
        <main>
          {/* <BannerEight/> */}
          <BannerOne />
          {/* <VideoBanner  src="/assets/images/v2vimages/v2vVideo.mp4"/> */}
          <AboutSix />
          <WorkingProcessThree />

          <WhychooseUs />
          <CounterTwo/>
          <ServiceFour />
          <Pricing />
          <Portfolio/>
          <PortfolioSix />
          <TestimonialsBrand />

          {/* <TeamMembers/> */}
          {/* <PortfolioTwo/> */}
          {/* <ContactTwo/> */}
          {/* <BrandTwo/> */}
          {/* <FooterSix/> */}
        </main>
      </div>
    </div>
  );
}

export default HomeEight;
